import React from 'react';
import { useRouteMatch } from 'react-router';

import { ReportProdPositivo } from 'pages/Reports/ReportPositivo';

import { Route } from '../Route';

export const ReportPositivoRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <>
      <Route isPrivate path={`${path}/report-prod-positivo`} component={ReportProdPositivo} />
    </>
  );
};
